import React from "react";

const Timer = ({
  hours = 0,
  minutes = 0,
  seconds = 0,
  url = "",
  //   playing = false,
  onEnded,
  onDuration,
}) => {
  const [paused, setPaused] = React.useState(false);
  const [over, setOver] = React.useState(false);
  const [[h, m, s], setTime] = React.useState([hours, minutes, seconds]);

  const tick = () => {
    if (paused || over) return;
    if (h === 0 && m === 0 && s === 0) setOver(true);
    else if (m === 0 && s === 0) {
      setTime([h - 1, 59, 59]);
    } else if (s == 0) {
      setTime([h, m - 1, 59]);
    } else {
      setTime([h, m, s - 1]);
    }
  };

  const reset = () => {
    setTime([parseInt(hours), parseInt(minutes), parseInt(seconds)]);
    setPaused(false);
    setOver(false);
  };

  React.useEffect(() => {
    if (over) {
      //   reset();
      onEnded();
    }
  }, [over]);

  React.useEffect(() => {
    const timerID = setInterval(() => tick(), 1000);
    return () => clearInterval(timerID);
  });

  React.useEffect(() => {}, [onEnded]);

  React.useEffect(() => {
    onDuration(`${seconds - s.toString().padStart(2, "0")}`);
  }, [h, m, s]);

  return (
    <>
      {/* {imgUrl && <img src={imgUrl} alt="banner image" importance="high"></img>} */}
      {`${h.toString().padStart(2, "0")}:${m.toString().padStart(2, "0")}:${s
        .toString()
        .padStart(2, "0")}`}
      {/* <div>{over ? "Time's up!" : ""}</div>
      <button onClick={() => setPaused(!paused)}>
        {paused ? "Resume" : "Pause"}
      </button>
      <button onClick={() => reset()}>Restart</button> */}
    </>
  );
};
export default Timer;
